var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFE68D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 37.95H53.2V56.45C51.3333 57.0833 49.3833 57.5833 47.35 57.95C45.35 58.3167 43.0667 58.5 40.5 58.5C36.9667 58.5 33.95 57.8 31.45 56.4C28.9833 55 27.1 52.9333 25.8 50.2C24.5333 47.4667 23.9 44.1 23.9 40.1C23.9 36.3667 24.6167 33.1333 26.05 30.4C27.5167 27.6667 29.6333 25.55 32.4 24.05C35.1667 22.55 38.55 21.8 42.55 21.8C44.45 21.8 46.3167 22 48.15 22.4C49.9833 22.8 51.65 23.3333 53.15 24L50.65 30.05C49.55 29.4833 48.3 29.0167 46.9 28.65C45.5 28.2833 44.0333 28.1 42.5 28.1C40.3 28.1 38.3833 28.6 36.75 29.6C35.15 30.6 33.9 32.0167 33 33.85C32.1333 35.65 31.7 37.7833 31.7 40.25C31.7 42.5833 32.0167 44.65 32.65 46.45C33.2833 48.25 34.2833 49.6667 35.65 50.7C37.0167 51.7 38.8 52.2 41 52.2C41.7333 52.2 42.3667 52.1833 42.9 52.15C43.4667 52.0833 43.9833 52.0167 44.45 51.95C44.9167 51.85 45.3667 51.7667 45.8 51.7V44.25H39.05V37.95Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankG);
export default __webpack_public_path__ + "static/media/rank_g.a639900ce56d025567834576f6e8524c.svg";
export { ForwardRef as ReactComponent };